<template>
  <div class="richieste-di-quotazione">
    <div class="row row-custom">
      <div class="titolo-app col-lg-20 col-md-19 col-sm-17 col-1 no-padding">
        <span class="titolo-bold d-none d-sm-block">
          {{ $t('richiesteDiQuotazione.richiesteDiQuotazione').toUpperCase() }}
        </span>
      </div>
      <div class="icone col-lg-4 col-md-5 col-sm-7 col-23 no-padding" v-show="showIndietro">
        <div class="icona" @click="indietro">
          <div class="icona-menu">
            <icon name="riv-lista" flip="horizontal" scale="1.5"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('richiesteDiQuotazione.listaQuotazioni')"></span>
          </div>
        </div>
      </div>
    </div>
    <div id="contenitore" class="contenitore col-24 no-padding"
         :style="{ height: contenitoreHeight + 'px', overflowY: (showScroll) ? 'auto' : 'hidden' }">
      <keep-alive>
        <router-view @hideScroll="hideScroll" @showScroll="showScroll = true" :contenitoreHeight="contenitoreHeight"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RichiesteDiQuotazione',
    props: {
      contenitoreHeight: {
        type: Number,
        required: true,
        default: 550
      }
    },
    i18n: {
      messages: {
        it_IT: {
          richiesteDiQuotazione: {
            listaQuotazioni: 'Lista<br>Quotazioni',
            richiesteDiQuotazione: 'Richieste di Quotazione'
          }
        },
        fr_FR: {
          richiesteDiQuotazione: {
            listaQuotazioni: 'Liste<br>Devis',
            richiesteDiQuotazione: 'Requêtes de Devis'
          }
        },
        es_ES: {
          richiesteDiQuotazione: {
            listaQuotazioni: 'Lista<br>Ofertas',
            richiesteDiQuotazione: 'Peticiones de Oferta (Servicios)'
          }
        },
        de_DE: {
          richiesteDiQuotazione: {
            listaQuotazioni: 'Liste<br>Angebote',
            richiesteDiQuotazione: 'Angebotsanfragen'
          }
        },
        en_GB: {
          richiesteDiQuotazione: {
            listaQuotazioni: 'Lista<br>Quotazioni',
            richiesteDiQuotazione: 'Richieste di Quotazione'
          }
        }
      }
    },
    data () {
      return {
        showScroll: true
      }
    },
    methods: {
      hideScroll: function () {
        var container = this.$el.querySelector('#contenitore')
        container.scrollTop = 0
        this.showScroll = false
      },
      indietro: function () {
        this.$router.push({name: 'RdQQuotazioni'})
      }
    },
    computed: {
      showIndietro: function () {
        let path = this.$route.path
        return (path.indexOf('/fornitura/richiestediquotazione/quotazione') >= 0)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .richieste-di-quotazione {
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px, @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: right;
      .icona:hover {
        cursor: pointer;
      }
      .icona {
        text-align: center;
        width: 170px;
        display: inline-block;
      }
      .icona-menu {
        padding-left: 0px;
        padding-right: 3px;
        // padding-top: 3px;
        text-align: right;
        display: inline-block;
        vertical-align: middle;
      }
      .label-menu {
        .set-font(@size: 13px, @family: 'os-semibold');
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        line-height: 17px;
        // margin-top: -4px;
      }
    }
    .contenitore {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow-x: hidden;
      border-radius: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Fornitura/RichiesteDiQuotazione/RichiesteDiQuotazione.vue